import { FC, useContext } from "react";
import GenericModalV2 from "../GenericModal/GenericModal";
import { ConfirmModalContext } from "../../providers/confirmModalProvider";
import CustomButton from "../CustomButton/CustomButton";
import Typhography from "../Typhography/Typhography";

export const ConfirmModal: FC = () => {
  const { state, setState } = useContext(ConfirmModalContext);

  const onConfirmClick = () => {
    state?.onConfirm();
    setState(undefined);
  };
  const onClose = () => {
    setState(undefined);
  };

  return (
    <GenericModalV2
      title={state?.title || ""}
      size={"lg"}
      isOpen={!!state}
      onClose={onClose}
      Footer={
        <>
          <CustomButton color="outline" onClick={onClose}>
            Annulla
          </CustomButton>
          <CustomButton color="secondary" onClick={onConfirmClick}>
            Conferma
          </CustomButton>
        </>
      }
    >
      <Typhography className="mb-3">{state?.description || ""}</Typhography>
    </GenericModalV2>
  );
};
